export default __webpack_public_path__ + "64b87e073b181e47d3a522c727da935a.png";